var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-footer',{staticClass:"justify-center",style:(_vm.getThemeStyle),attrs:{"height":"40","absolute":""}},[_c('div',{staticClass:"title font-weight-light text--lighten-1 text-center"},[_vm._v(" Created By Kenny [076 243 9441 / 081 482 6615 ]   |   © "+_vm._s(new Date().getFullYear())+" — "+_vm._s(_vm.getAppName)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }